(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
(function () {
  function startAutoRotate() {
    if (!window.jQuery || !jQuery.fn.slick) {
      return false;
    }

    var found = false;

    jQuery('.js-slideshow-v1').each(function () {
      var slider = jQuery(this);

      if (slider.hasClass('slick-initialized')) {
        found = true;

        slider.slick('slickSetOption', 'autoplay', true, false);
        slider.slick('slickSetOption', 'autoplaySpeed', 2000, false);
        slider.slick('slickSetOption', 'fade', true, false);
        slider.slick('slickSetOption', 'speed', 2500, false);
        slider.slick('slickPlay');
      }
    });

    return found;
  }

  var tries = 0;

  var checkSlider = setInterval(function () {
    tries++;

    if (startAutoRotate() || tries >= 40) {
      clearInterval(checkSlider);
    }
  }, 500);
})();

  } catch(e) { console.error(e); }
})();
})();
